import ProductList from '@frontend/features/product-list/ProductList'
import { usePostBySlug } from '@frontend/libs/hooks/usePost'
import ErrorBoundary from '@shared/ErrorBoundary'
import { useErrorBoundary } from 'react-error-boundary'
import toast from 'react-hot-toast'

function Content() {
  const { showBoundary } = useErrorBoundary()
  const { data: post, error } = usePostBySlug('chinese-new-year')

  if (error) {
    toast.error('Failed to fetch page')
    showBoundary(error)
  }

  if (post) {
    document.title = post.meta.title

    const styleTag = document.getElementById('core-block-supports-inline-css')

    if (styleTag) {
      styleTag.innerHTML = post.styles
    } else {
      const style = document.createElement('style')
      style.id = 'core-block-supports-inline-css'
      document.head.appendChild(style)
      style.innerHTML = post.styles
    }
  }

  return (
    <ProductList
      brand={['asava', 'asv']}
      category="chinese-new-year"
      showBrandFilter={false}
      showCategoryFilter={false}
      showCollectionFilter={false}
      showColorFilter={false}
      showDiscountFilter={false}
      showSizeFilter={false}
      type="default"
    />
  )
}

export function ChineseNewYear() {
  return (
    <ErrorBoundary>
      <Content />
    </ErrorBoundary>
  )
}

export default ChineseNewYear
